module.exports = __webpack_public_path__ + "img/ИФ-1(А)-051.92684935.png";